'use client';

import { addDays } from 'date-fns';
import { useEffect } from 'react';

import { useCookie } from '@flipster/react/misc/browser/cookie';
import { CookieKeys } from '@flipster/utils/cookie';

export const ReferralCapture = () => {
  const [, setReferralCode] = useCookie(CookieKeys.ReferralCode);
  const [, setReferralType] = useCookie(CookieKeys.ReferralType);

  useEffect(() => {
    // 계속 바뀌는게 아니라 초기 1회 접속시만 체크하면 되기때문에 useSearchParams 를 쓰지 않음
    const searchParams = new URLSearchParams(window.location.search);
    const referralCode = searchParams.get('referral_code');
    const referralType = searchParams.get('referral_type');

    if (referralCode) {
      setReferralCode(referralCode, addDays(new Date(), 30));
    }
    if (referralType && ['copy', 'share'].includes(referralType)) {
      setReferralType(referralType, addDays(new Date(), 30));
    }
  }, [setReferralCode, setReferralType]);

  return null;
};
